export enum SubscriptionType {
    basic = 'Basic',
    marketMonitoring = 'Market Monitoring',
    primaryIssuance = 'Primary Issuance',
    secondaryMarkets = 'Secondary Markets',
    pro = 'Pro',
    trial = 'Trial'
}

export enum EvalSubscriptionRequestType {
    EvalBasic='EvalBasic',
    EvalPro='EvalPro'
}

export function isSubscriptionObsolete(subscriotion: SubscriptionType) {
    return subscriotion === SubscriptionType.primaryIssuance ||
        subscriotion === SubscriptionType.secondaryMarkets
}

export function getEvalSubscriptionTitle(subscription: SubscriptionType) {
    switch (subscription) {
        case SubscriptionType.pro: return 'Full Universe';
        default:
            return subscription.toString();
    }
}